:host {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

iframe {
  position: relative;
  aspect-ratio: 560 / 315;
  height: 100%;
}

.bg {
  display: flex;
  align-items: center;
  justify-content: center;

  &, img {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  img {
    object-fit: cover;
    filter: brightness(75%);
    animation: 300ms appear ease-in;
  }
}

svg {
  position: relative;
  max-width: 20%;
  max-height: 20%;
  opacity: 0;
  animation: 300ms appear 1s ease-in forwards,
             3s spin infinite;

  circle:nth-of-type(1) {
    stroke: #fff;
    opacity: 0.2;
  }

  circle:nth-of-type(2) {
    stroke: #fff;
  }
}

@keyframes appear {
  0% { opacity: 0; }
  100% { opacity: 1; }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
